import React from "react";

import { Box, Container } from "@mui/material";
import MainNavigation from "@/components/MainNavigation/MainNavigation";

import NotificationGroups from "./NotificationGroups";
import NotificationDeliveryProfile from "./NotificationDeliveryProfile";
import NotificationDigest from "./NotificationDigest";
import { MenuItemEnum } from "@/utils/utils";

import "./Notifications.css";

const NotificationConfig = () => {
  return (
    <Container>
      <MainNavigation selected={MenuItemEnum.Notifications} />
      <Box
        className="content-container"
        style={{
          boxSizing: "border-box",
        }}
      >
        <div className="pageTitle">Notifications Setup</div>
        <NotificationGroups />
        <NotificationDeliveryProfile />
        <NotificationDigest />
      </Box>
    </Container>
  );
};

export default NotificationConfig;
